import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Aprovacoes, Despesas } from './Despesas';
import { i18n } from './i18n';
import { PorCentro } from './PorCentro';
import { Reembolsos } from './Reembolsos';
import { buscaDespesas } from './busca-global';

/** Pacote 2 (onda 1a): Despesas e reembolso, na linha do Financeiro depois de A pagar. */
const modulo: ModuloWeb = {
  slug: 'despesas',
  menu: 'financeiro',
  ordem: 40,
  abas: [
    { chave: 'despesas', permissao: 'despesas.ver', componente: Despesas, posicao: 22 },
    { chave: 'aprovacoes', permissao: 'despesas.aprovar', componente: Aprovacoes, posicao: 24 },
    { chave: 'reembolsos', permissao: 'despesas.ver', componente: Reembolsos, posicao: 26 },
    // r64 SPEC-B5: relatório por centro de custo (aprovadas e reembolsadas no período).
    { chave: 'centros', avancada: true, permissao: 'despesas.ver', componente: PorCentro, posicao: 28 },
  ],
  i18n,
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaDespesas,
};

export default modulo;
